import { Outlet } from "react-router-dom";
import Navbar from "@/shared/components/layout/Navbar";

const DashboardLayout = () => {
  const roleThemeClass = "cc-patient-scope";

  return (
    <div className={`app-layout ${roleThemeClass}`}>
      <Navbar />
      <main className="app-main">
        <div className="content-shell">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default DashboardLayout;
